<account-back [title]="'Marketing preferences'"
              class="m-b-9 m-b-7-s m-b-7-m m-t--1 block p-l-2"></account-back>
<div class="p2 col-1 bg-col-w p-l-10 p-l-4-s p-r-10 p-r-4-s p-t-15 p-t-10-s p-b-15 p-b-20-s m-r--4-s m-l--4-s m-b--4-s">
    <p class="p-b-5 m-t--1"> If you’re receiving marketing from us by email and would like to unsubscribe, you can do
        this by clicking the unsubscribe link at the bottom of our marketing emails.</p>
    <p class="p-b-6 p-b-5-s"> To unsubscribe from text messages, text TERM to 86688.</p>
    <p>
        If you need further assistance, please email aftersales&#64;barkerandstonehouse.co.uk or give our customer services
        team a call on 0333 010 2353. And for information about how your data is used and stored, please read our
        privacy policy. We’d love to keep you in the loop with exclusive offers, new product launches and business
        updates.
    </p>
</div>
